import { render, staticRenderFns } from "./01_LE_IdentificationForm.vue?vue&type=template&id=5206c3b8&"
import script from "./01_LE_IdentificationForm.vue?vue&type=script&lang=js&"
export * from "./01_LE_IdentificationForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports